import React from 'react';
import { Colors as C } from '../../constants/Colors.js';
import { GENEROS_TREE, GENERACIONES, DECADAS, CONDITIONS_INFO } from '../../constants/musicConstants.js';
import { MARKET_SORT_OPTIONS } from '../marketplaceConstants.js';
import { MP_SURF } from '../constants/surfaces.js';
import { MarketplaceSearchSections } from './MarketplaceControls.js';
import Fsection from './Fsection.js';

const iStyle = {
  width: '100%',
  padding: '7px 9px',
  border: MP_SURF.inputBorder,
  borderRadius: 6,
  fontSize: '0.79rem',
  outline: 'none',
  background: MP_SURF.inputBg,
  color: MP_SURF.text,
  transition: 'border-color .18s',
  fontFamily: 'inherit',
};

/**
 * Panel de filtros del mercado principal — compartido con Subastas (mismo estado en el padre).
 */
export default function MarketplaceFiltersSidebar({
  filters,
  actions,
  tooltipCond,
  setTooltipCond,
  embeddedInDrawer = false,
  maxSavedFilters = 5,
  filterSlotPurchase = null,
}) {
  const {
    busqueda,
    setBusqueda,
    provinciaSel,
    setProvinciaSel,
    municipioSel,
    setMunicipioSel,
    generoInput,
    setGeneroInput,
    generosSel,
    setGenerosSel,
    generoCategoria,
    setGeneroCategoria,
    tiposSel,
    setTiposSel,
    condFiltros,
    setCondFiltros,
    genFiltros,
    decadaFiltros,
    precioRange,
    setPrecioRange,
    precioMaxUi,
    setFiltrosAplicados,
    nombreFiltro,
    setNombreFiltro,
    savedFilters,
    setSavedFilters,
    generosAC,
    distanciaKmFiltro,
    userLat,
    userLng,
    loadingGeo,
    geoNearbyError,
    setDistanciaKmFiltro,
    ordenar,
    setOrdenar,
  } = filters;

  const {
    limpiar,
    toggleTipo,
    addGenero,
    toggleGeneroSel,
    removeGenero,
    toggleCond,
    toggleGen,
    toggleDecada,
    onGeneroInputBlur,
    activarFiltroDistancia,
    desactivarFiltroDistancia,
  } = actions;

  const asideLayout = embeddedInDrawer
    ? { position: 'relative', top: 'auto', borderRadius: 10, padding: 0, border: 'none', background: 'transparent' }
    : { position: 'sticky', top: 70, borderRadius: 11, padding: 16, border: MP_SURF.cardBorder, background: MP_SURF.card };

  return (
    <aside style={{ ...asideLayout }}>
      {!embeddedInDrawer ? (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <span style={{ fontWeight: 700, fontSize: '0.86rem', color: MP_SURF.text }}>Filtros</span>
        <button type="button" onClick={limpiar} style={{ background: 'none', border: 'none', color: MP_SURF.textDim, fontSize: '0.7rem', cursor: 'pointer' }}>Limpiar</button>
      </div>
      ) : null}
      <MarketplaceSearchSections
        busqueda={busqueda}
        onBusquedaChange={setBusqueda}
        distanciaKmFiltro={distanciaKmFiltro}
        userLat={userLat}
        userLng={userLng}
        loadingGeo={loadingGeo}
        geoNearbyError={geoNearbyError}
        onActivarFiltroDistancia={activarFiltroDistancia}
        onDesactivarFiltroDistancia={desactivarFiltroDistancia}
        onDistanciaKmChange={setDistanciaKmFiltro}
        ubicacionProvincia={provinciaSel}
        ubicacionMunicipio={municipioSel}
        onUbicacionProvinciaChange={v => {
          setProvinciaSel(v);
          setMunicipioSel('');
        }}
        onUbicacionMunicipioChange={setMunicipioSel}
        goldColor={C.gold}
        inputStyle={iStyle}
      />

      <Fsection label="Orden del listado">
        <select
          value={ordenar}
          onChange={e => setOrdenar(e.target.value)}
          style={{ ...iStyle, width: '100%', cursor: 'pointer', color: '#444' }}
        >
          {MARKET_SORT_OPTIONS.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {embeddedInDrawer ? (
          <div style={{ fontSize: '0.62rem', color: MP_SURF.textDim, marginTop: 6, lineHeight: 1.4 }}>
            Atajo en la barra del listado: <strong>Novedades</strong> y <strong>Recomendaciones</strong> (partners).
          </div>
        ) : null}
      </Fsection>

      <Fsection label={`Género${generosSel.length ? ` (${generosSel.length})` : ''}`}>
        {generosSel.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 7 }}>
            {generosSel.map(g => (
              <span key={g} style={{ background: 'rgba(200,168,75,0.12)', color: C.gold, padding: '2px 7px', borderRadius: 9, fontSize: '0.68rem', display: 'flex', alignItems: 'center', gap: 3 }}>
                {g}
                <span onClick={() => removeGenero(g)} style={{ cursor: 'pointer', fontWeight: 700, opacity: 0.65 }}>×</span>
              </span>
            ))}
          </div>
        )}
        <div style={{ position: 'relative' }}>
          <input
            value={generoInput}
            onChange={e => setGeneroInput(e.target.value)}
            placeholder="Escribe un género..."
            style={iStyle}
            onFocus={e => { e.target.style.borderColor = C.gold; }}
            onBlur={e => { e.target.style.borderColor = 'rgba(0,0,0,0.14)'; onGeneroInputBlur(); }}
          />
          {generosAC.length > 0 && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: MP_SURF.card, border: MP_SURF.cardBorder, borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,0.45)', zIndex: 50 }}>
              {generosAC.map(g => (
                <div key={g} className="ac-item" onMouseDown={() => addGenero(g)} style={{ padding: '7px 11px', fontSize: '0.8rem', display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}>
                  <span>{g}</span>
                  <span style={{ fontSize: '0.62rem', color: MP_SURF.textDim }}>{Object.entries(GENEROS_TREE).find(([, v]) => v.includes(g))?.[0]}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <div style={{ marginTop: 7, display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'stretch' }}>
          {Object.keys(GENEROS_TREE).map(cat => {
            const catSelected = generosSel.includes(cat);
            const expanded = generoCategoria === cat;
            return (
              <div key={cat} style={{ display: 'inline-flex', borderRadius: 9, border: `1px solid ${catSelected ? C.gold : MP_SURF.chipInactiveBorder}`, overflow: 'hidden', background: MP_SURF.chipInactiveBg }}>
                <button
                  type="button"
                  title="Filtra toda la categoría (cualquier subgénero). Clic otra vez para quitar."
                  onClick={() => toggleGeneroSel(cat)}
                  style={{
                    padding: '3px 8px',
                    border: 'none',
                    background: catSelected ? 'rgba(200,168,75,0.2)' : 'transparent',
                    color: catSelected ? C.gold : MP_SURF.chipInactiveColor,
                    fontSize: '0.65rem',
                    cursor: 'pointer',
                    fontWeight: catSelected ? 600 : 400,
                    fontFamily: 'inherit',
                  }}
                >
                  {cat}
                </button>
                <button
                  type="button"
                  title="Ver subgéneros"
                  onClick={e => {
                    e.stopPropagation();
                    setGeneroCategoria(expanded ? null : cat);
                  }}
                  style={{
                    padding: '3px 7px',
                    border: 'none',
                    borderLeft: `1px solid ${MP_SURF.divider}`,
                    background: expanded ? 'rgba(200,168,75,0.2)' : 'rgba(255,255,255,0.04)',
                    color: expanded ? C.gold : MP_SURF.textMuted,
                    fontSize: '0.58rem',
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    lineHeight: 1,
                  }}
                >
                  ▼
                </button>
              </div>
            );
          })}
        </div>
        <div style={{ fontSize: '0.6rem', color: MP_SURF.textDim, marginTop: 5, lineHeight: 1.35 }}>
          Nombre: toda la familia · ▼: subgéneros · subgénero otra vez: quita
        </div>
        {generoCategoria && (
          <div style={{ marginTop: 7, background: 'rgba(255,255,255,0.04)', borderRadius: 7, padding: 8, border: MP_SURF.cardBorder }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
              {GENEROS_TREE[generoCategoria].map(g => {
                const on = generosSel.includes(g);
                return (
                  <button
                    key={g}
                    type="button"
                    onMouseDown={() => toggleGeneroSel(g)}
                    style={{
                      padding: '2px 7px',
                      borderRadius: 9,
                      border: `1px solid ${on ? C.gold : MP_SURF.chipInactiveBorder}`,
                      background: on ? MP_SURF.chipActiveBg : 'transparent',
                      color: on ? C.gold : MP_SURF.chipInactiveColor,
                      fontSize: '0.68rem',
                      cursor: 'pointer',
                      fontFamily: 'inherit',
                    }}
                  >
                    {g}
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </Fsection>

      <Fsection label="Formato">
        <button type="button" className="sf-btn" onClick={() => setTiposSel([])} style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '6px 7px', borderRadius: 5, border: 'none', background: tiposSel.length === 0 ? 'rgba(200,168,75,0.09)' : 'transparent', cursor: 'pointer', textAlign: 'left', fontSize: '0.81rem', color: tiposSel.length === 0 ? C.gold : MP_SURF.chipInactiveColor, fontWeight: tiposSel.length === 0 ? 600 : 400, width: '100%', transition: 'background .13s' }}>
          <div style={{ width: 12, height: 12, borderRadius: 2.5, border: `1.5px solid ${tiposSel.length === 0 ? C.gold : '#ccc'}`, background: tiposSel.length === 0 ? C.gold : 'transparent', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {tiposSel.length === 0 && <svg width="7" height="7" viewBox="0 0 12 12"><path d="M2 6l3 3 5-5" stroke="#000" strokeWidth="2.5" fill="none" /></svg>}
          </div>
          Todos
        </button>
        {[['VINILO', 'Vinilo'], ['CD', 'CD'], ['CASETE', 'Casete'], ['BLURAY', 'Blu-ray Audio']].map(([val, lbl]) => {
          const sel = tiposSel.includes(val);
          return (
            <button key={val} type="button" className="sf-btn" onClick={() => toggleTipo(val)} style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '6px 7px', borderRadius: 5, border: 'none', background: sel ? 'rgba(200,168,75,0.09)' : 'transparent', cursor: 'pointer', textAlign: 'left', fontSize: '0.81rem', color: sel ? C.gold : MP_SURF.chipInactiveColor, fontWeight: sel ? 600 : 400, width: '100%', transition: 'background .13s' }}>
              <div style={{ width: 12, height: 12, borderRadius: 2.5, border: `1.5px solid ${sel ? C.gold : '#ccc'}`, background: sel ? C.gold : 'transparent', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {sel && <svg width="7" height="7" viewBox="0 0 12 12"><path d="M2 6l3 3 5-5" stroke="#000" strokeWidth="2.5" fill="none" /></svg>}
              </div>
              {lbl}
            </button>
          );
        })}
      </Fsection>

      <Fsection label="Estado del disco">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }} onMouseLeave={() => setTooltipCond(null)}>
          {CONDITIONS_INFO.map(c => (
            <button key={c.code} type="button" onMouseEnter={() => setTooltipCond(c.code)} onClick={() => toggleCond(c.code)} style={{ padding: '3px 8px', borderRadius: 9, border: `1px solid ${condFiltros.includes(c.code) ? C.gold : 'rgba(0,0,0,0.13)'}`, background: condFiltros.includes(c.code) ? 'rgba(200,168,75,0.11)' : 'transparent', color: condFiltros.includes(c.code) ? C.gold : MP_SURF.chipInactiveColor, fontSize: '0.74rem', fontWeight: 600, cursor: 'pointer', transition: 'all .13s' }}>
              {c.code}
            </button>
          ))}
        </div>
        {tooltipCond && (() => {
          const c = CONDITIONS_INFO.find(x => x.code === tooltipCond);
          if (!c) return null;
          return (
            <div style={{ marginTop: 8, background: '#1a1a2e', color: '#fff', padding: '7px 10px', borderRadius: 8, fontSize: '0.72rem', lineHeight: 1.35, boxShadow: '0 3px 10px rgba(0,0,0,0.12)' }}>
              <strong>{c.label}</strong>
              <div style={{ opacity: 0.85 }}>{c.desc}</div>
            </div>
          );
        })()}
        <div style={{ fontSize: '0.62rem', color: MP_SURF.textDim, marginTop: 6 }}>Pasa el ratón para ver descripción</div>
      </Fsection>

      <Fsection label="Época musical">
        {GENERACIONES.map(g => (
          <button key={g.code} type="button" className="sf-btn" onClick={() => toggleGen(g.code)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 8px', borderRadius: 7, border: `1px solid ${genFiltros.includes(g.code) ? C.gold : 'rgba(0,0,0,0.08)'}`, background: genFiltros.includes(g.code) ? 'rgba(200,168,75,0.07)' : 'transparent', cursor: 'pointer', width: '100%', marginBottom: 4, textAlign: 'left', transition: 'all .13s' }}>
            <div>
              <div style={{ fontSize: '0.75rem', fontWeight: 600, color: genFiltros.includes(g.code) ? C.gold : MP_SURF.text }}>{g.label}</div>
              <div style={{ fontSize: '0.6rem', color: '#bbb' }}>{g.years} · {g.desc}</div>
            </div>
            {genFiltros.includes(g.code) && <svg width="10" height="10" viewBox="0 0 12 12"><path d="M2 6l3 3 5-5" stroke={C.gold} strokeWidth="2.5" fill="none" /></svg>}
          </button>
        ))}
      </Fsection>

      <Fsection label="Décadas">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
          {DECADAS.map(d => (
            <button key={d} type="button" onClick={() => toggleDecada(d)} style={{ padding: '3px 9px', borderRadius: 9, border: `1px solid ${decadaFiltros.includes(d) ? C.gold : 'rgba(0,0,0,0.13)'}`, background: decadaFiltros.includes(d) ? 'rgba(200,168,75,0.11)' : 'transparent', color: decadaFiltros.includes(d) ? C.gold : MP_SURF.chipInactiveColor, fontSize: '0.74rem', fontWeight: 600, cursor: 'pointer', transition: 'all .13s' }}>
              {d}
            </button>
          ))}
        </div>
      </Fsection>

      <Fsection label="Precio" last>
        {(() => {
          const max = Math.max(50, Number(precioMaxUi) || 300);
          const minSel = Math.max(0, Number(precioRange[0]) || 0);
          const maxSel = Math.min(max, Number(precioRange[1]) || max);
          const pct = v => (max > 0 ? (v / max) * 100 : 0);
          const maxIsUnlimited = maxSel === max;
          return (
            <>
              <div style={{ position: 'relative', marginBottom: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                  <span style={{ fontSize: '0.72rem', color: MP_SURF.textMuted }}>Mín</span>
                  <span style={{ fontSize: '0.72rem', color: C.gold, fontWeight: 700 }}>
                    {minSel}€ — {maxIsUnlimited ? 'Sin límite' : `${maxSel}€`}
                  </span>
                  <span style={{ fontSize: '0.72rem', color: MP_SURF.textMuted }}>Máx</span>
                </div>
                <div style={{ position: 'relative', height: 6, background: 'rgba(255,255,255,0.1)', borderRadius: 3, marginBottom: 4 }}>
                  <div style={{ position: 'absolute', left: `${pct(minSel)}%`, right: `${100 - pct(maxSel)}%`, height: '100%', background: C.gold, borderRadius: 3 }} />
                  <div style={{ position: 'absolute', left: `${pct(minSel)}%`, top: '50%', transform: 'translate(-50%,-50%)', width: 14, height: 14, borderRadius: '50%', background: C.gold, border: '2px solid #fff', boxShadow: '0 1px 4px rgba(0,0,0,0.2)', cursor: 'pointer' }} />
                  <div style={{ position: 'absolute', left: `${pct(maxSel)}%`, top: '50%', transform: 'translate(-50%,-50%)', width: 14, height: 14, borderRadius: '50%', background: C.gold, border: '2px solid #fff', boxShadow: '0 1px 4px rgba(0,0,0,0.2)', cursor: 'pointer' }} />
                </div>
                <input type="range" min="0" max={max} step="5" value={minSel} onChange={e => { const v = +e.target.value; if (v < maxSel - 10) setPrecioRange([v, maxSel]); }} style={{ position: 'absolute', top: 14, left: 0, width: '100%', opacity: 0, cursor: 'pointer', height: 20, zIndex: 2 }} />
                <input type="range" min="0" max={max} step="5" value={maxSel} onChange={e => { const v = +e.target.value; if (v > minSel + 10) setPrecioRange([minSel, v]); }} style={{ position: 'absolute', top: 14, left: 0, width: '100%', opacity: 0, cursor: 'pointer', height: 20, zIndex: 3 }} />
              </div>
              <div style={{ display: 'flex', gap: 6, minWidth: 0 }}>
                <input type="number" value={minSel} onChange={e => { const v = +e.target.value; if (v >= 0 && v < maxSel) setPrecioRange([v, maxSel]); }} style={{ flex: 1, minWidth: 0, width: '100%', padding: '5px 7px', border: MP_SURF.inputBorder, borderRadius: 6, fontSize: '0.76rem', outline: 'none', background: MP_SURF.inputBg, color: MP_SURF.text, textAlign: 'center' }} />
                <span style={{ alignSelf: 'center', color: '#ccc', fontSize: '0.8rem' }}>—</span>
                <input
                  type="number"
                  placeholder="Sin límite"
                  value={maxIsUnlimited ? '' : maxSel}
                  onChange={e => {
                    const raw = String(e.target.value || '').trim();
                    if (!raw) {
                      setPrecioRange([minSel, max]);
                      return;
                    }
                    const v = Number(raw);
                    if (Number.isFinite(v) && v <= max && v > minSel) setPrecioRange([minSel, v]);
                  }}
                  style={{ flex: 1, minWidth: 0, width: '100%', padding: '5px 7px', border: MP_SURF.inputBorder, borderRadius: 6, fontSize: '0.76rem', outline: 'none', background: MP_SURF.inputBg, color: MP_SURF.text, textAlign: 'center' }}
                />
              </div>
            </>
          );
        })()}
      </Fsection>

      <button type="button" onClick={() => setFiltrosAplicados(true)} style={{ width: '100%', background: C.gold, color: '#000', border: 'none', padding: '11px', borderRadius: 7, fontWeight: 800, fontSize: '0.82rem', cursor: 'pointer', marginBottom: 8, letterSpacing: '0.03em', marginTop: 10 }}>
        APLICAR FILTROS
      </button>

      <div style={{ marginTop: 4 }}>
        <div
          style={{
            fontSize: '0.68rem',
            fontWeight: 700,
            color: MP_SURF.labelMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.09em',
            marginBottom: 6,
          }}
        >
          Guardar esta búsqueda
        </div>
        <p style={{ margin: '0 0 8px', fontSize: '0.65rem', color: MP_SURF.textDim, lineHeight: 1.4 }}>
          Pon un nombre para recuperar estos filtros más tarde (hasta {maxSavedFilters} guardados).
        </p>
        <div style={{ display: 'flex', gap: 5, marginBottom: 6 }}>
          <input
            value={nombreFiltro}
            onChange={e => setNombreFiltro(e.target.value.slice(0, 30))}
            placeholder="Ej.: Vinilos (Género - Madrid)"
            aria-label="Nombre para guardar esta combinación de filtros"
            maxLength={30}
            style={{ ...iStyle, flex: 1, fontSize: '0.72rem' }}
            onFocus={e => { e.target.style.borderColor = C.gold; }}
            onBlur={e => { e.target.style.borderColor = MP_SURF.inputBorder; }}
          />
          <button
            type="button"
            disabled={!nombreFiltro.trim() || savedFilters.length >= maxSavedFilters}
            onClick={() => {
              if (nombreFiltro.trim() && savedFilters.length < maxSavedFilters) {
                setSavedFilters(p => [...p, { name: nombreFiltro.trim(), generos: generosSel, tipos: tiposSel, cond: condFiltros, precio: precioRange }]);
                setNombreFiltro('');
              }
            }}
            style={{
              padding: '7px 10px',
              borderRadius: 6,
              background: !nombreFiltro.trim() || savedFilters.length >= maxSavedFilters ? MP_SURF.chipInactiveBg : C.gold,
              color: !nombreFiltro.trim() || savedFilters.length >= maxSavedFilters ? MP_SURF.textDim : '#000',
              border: 'none',
              fontSize: '0.72rem',
              cursor: !nombreFiltro.trim() || savedFilters.length >= maxSavedFilters ? 'not-allowed' : 'pointer',
              fontWeight: 700,
              flexShrink: 0,
              opacity: !nombreFiltro.trim() || savedFilters.length >= maxSavedFilters ? 0.55 : 1,
            }}
          >
            Guardar
          </button>
        </div>
        <div style={{ fontSize: '0.6rem', color: MP_SURF.textDim, marginBottom: savedFilters.length ? 7 : 0 }}>
          {nombreFiltro.length}/30 caracteres · {savedFilters.length}/{maxSavedFilters} guardados
        </div>
        {filterSlotPurchase?.canPurchase ? (
          <button
            type="button"
            disabled={filterSlotPurchase.busy}
            onClick={filterSlotPurchase.onPurchase}
            style={{
              width: '100%',
              marginBottom: 8,
              padding: '8px 10px',
              borderRadius: 6,
              border: '0.5px solid rgba(200,168,75,0.35)',
              background: 'rgba(200,168,75,0.08)',
              color: C.gold,
              fontSize: '0.68rem',
              fontWeight: 600,
              cursor: filterSlotPurchase.busy ? 'wait' : 'pointer',
            }}
          >
            {filterSlotPurchase.busy
              ? 'Comprando slot…'
              : `+1 filtro guardado · ${filterSlotPurchase.cost ?? 40} Grooves`}
          </button>
        ) : null}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
          {savedFilters.map((f, i) => (
            <div key={f.name + i} style={{ display: 'flex', alignItems: 'center', gap: 3, padding: '3px 8px', borderRadius: 9, background: 'rgba(200,168,75,0.09)', border: '1px solid rgba(200,168,75,0.22)', cursor: 'pointer' }} onClick={() => { setGenerosSel(f.generos); setTiposSel(f.tipos || []); setCondFiltros(f.cond); setPrecioRange(f.precio); setFiltrosAplicados(true); }}>
              <span style={{ fontSize: '0.68rem', color: C.gold, fontWeight: 600 }}>{f.name}</span>
              <span onClick={e => { e.stopPropagation(); setSavedFilters(p => p.filter((_, j) => j !== i)); }} style={{ fontSize: '0.65rem', color: '#bbb', cursor: 'pointer', fontWeight: 700 }}>×</span>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}

